import {CommonModule} from "@angular/common";
import {Component, NgModule} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {HttpErrorResponse, HttpStatusCode} from "@angular/common/http";

import {TranslateModule} from "@ngx-translate/core";

import {ButtonModule} from "primeng/button";

import {MotoAiRegistrationService} from "../../shared/service/moto-ai-registration.service";

@Component({
  selector: 'app-unsubscribe',
  templateUrl: './unsubscribe.component.html',
  styleUrls: ['./unsubscribe.component.scss']
})
export class UnsubscribeComponent {

  isUnsubscribeSuccessful = false;

  constructor(
    private route: ActivatedRoute,
    private motoAiRegistrationService: MotoAiRegistrationService
  ) {
  }

  unsubscribeUser() {
    let userRef = '';
    let campaignName = '';

    this.route.queryParams.subscribe(params => {
      userRef = params['userRef'];
      campaignName = params['campaignName'];
    });

    this.motoAiRegistrationService.unsubscribeUser(userRef, campaignName)
      .subscribe(async () => {
        this.isUnsubscribeSuccessful = true;
      },
      (responseError: HttpErrorResponse) => {

        if (responseError.status === HttpStatusCode.Conflict) {
          this.isUnsubscribeSuccessful = true;
        }
      }
    );
  }

}

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    ButtonModule
  ],
  declarations: [UnsubscribeComponent],
  exports: [UnsubscribeComponent]
})
export class UnsubscribeModule {
}
